import React, { useState, useEffect, useCallback } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import debounce from 'lodash/debounce';
import ClipLoader from 'react-spinners/ClipLoader';

const override = {
    display: 'block',
    margin: '0 auto',
    borderColor: 'red',
};

const FormRow = ({ row, index, errorfield, handleChange, handleRemove, showDeleteButton }) => {
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        handleChange(row.id, name, value);
    };

    const handleDateChange = (date) => {
        //handleChange(index, 'date', date);
        handleChange(row.id, 'date', date);
    };


    const [queryFrom, setQueryFrom] = useState('');
    const [queryTo, setQueryTo] = useState('');
    const [resultsFrom, setResultsFrom] = useState([]);
    const [resultsTo, setResultsTo] = useState([]);
    const [selectedFrom, setSelectedFrom] = useState('');
    const [selectedTo, setSelectedTo] = useState('');
    const [loadingFrom, setLoadingFrom] = useState(false);
    const [loadingTo, setLoadingTo] = useState(false);
    const [error, setError] = useState('');
    const [fromError, setFromError] = useState(false);
    const [toError, setToError] = useState('');

    const [dateError, setDateError] = useState('');
    const [timeError, setTimeError] = useState('');

    const fetchResults = async (searchQuery, setLoading, setResults) => {
        setError('');
        setResults([]);
        setLoading(true);
        try {
            // Encode the search query to handle special characters
            const encodedQuery = encodeURIComponent(searchQuery);
            // Replace with actual API endpoint
            const response = await fetch(
                `${airportappLocalizer.apiUrl}/airport/v1/search?code=${encodedQuery}`
            );
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            setResults(data);
        } catch (error) {
            setError('Failed to fetch data: ' + error.message);
            console.log('Failed to fetch data: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    const debouncedFetchResultsFrom = useCallback(
        debounce((searchQuery) => {
            if (searchQuery.length >= 2) {
                fetchResults(searchQuery, setLoadingFrom, setResultsFrom);
            } else {
                setResultsFrom([]);
            }
        }, 300), // 300ms delay
        []
    );

    const debouncedFetchResultsTo = useCallback(
        debounce((searchQuery) => {
            if (searchQuery.length >= 2) {
                fetchResults(searchQuery, setLoadingTo, setResultsTo);
            } else {
                setResultsTo([]);
            }
        }, 300), // 300ms delay
        []
    );

    useEffect(() => {
        const handleBodyClick = (event) => {
            if (!event.target.closest('.autosuggestion_from') && !event.target.closest('.autosuggestion_to')) {
                setResultsFrom([]);
                setResultsTo([]);
                document.body.removeEventListener('click', handleBodyClick);
            }
        };

        if (resultsFrom.length > 0 || resultsTo.length > 0) {
            document.body.addEventListener('click', handleBodyClick);
        }

        return () => {
            document.body.removeEventListener('click', handleBodyClick);
        };
    }, [resultsFrom, resultsTo]);

    const handleSuggestionClickFrom = (result) => {
        const selectedText = `${result.air_name} - ${result.air_place} (${result.air_code})`;
        setSelectedFrom(selectedText);
        setQueryFrom(selectedText);
        setResultsFrom([]);
        handleChange(index, 'from', result.air_name); // Update form state with selected value
        setFromError(''); // Clear error on selection
        //console.log(queryFrom);
    };

    const handleSuggestionClickTo = (result) => {
        const selectedText = `${result.air_name} - ${result.air_place} (${result.air_code})`;
        setSelectedTo(selectedText);
        setQueryTo(selectedText);
        setResultsTo([]);
        handleChange(index, 'to', result.air_name); // Update form state with selected value
        setToError(''); // Clear error on selection
        //console.log(queryTo);
    };


    /*useEffect(() => {
         //validateInputs();
         setQueryFrom("");
         setQueryTo("");
    }, [row]);*/

    const generateTimeOptions = () => {
        const times = [];
        const periods = ['am', 'pm'];
      
        for (let i = 0; i < 24; i++) {
          const hour = i % 12 === 0 ? 12 : i % 12;
          const period = periods[Math.floor(i / 12)];
      
          times.push(`${hour.toString().padStart(2, '0')}:00${period}`);
          times.push(`${hour.toString().padStart(2, '0')}:30${period}`);
        }
      
        return times;
      };
      const timeOptions = generateTimeOptions();

    return (
        
        <div className={`form-inline-cont ${row.id} ${errorfield ? 'error-row' : ''} ${errorfield}`}>
            
            <div className="cust-form-group group-from-to group-from no-border">
                <input
                    className="cust-form-control from-input"
                    autoComplete="off"
                    autoCorrect="off"
                    type="text"
                    name="from"
                    value={queryFrom}
                    onChange={(e) => {
                        //setFromError('');
                        //setSelectedFrom('');
                        const { value } = e.target;
                        //setQueryFrom(value);
                        //debouncedFetchResultsFrom(value);
                        if (value === '') { 
                            setQueryFrom('');
                            debouncedFetchResultsFrom('');
                            //setResultsFrom([]);
                            handleChange(index, 'from', '');
                            //setSelectedFrom('');
                            //console.log("empty");
                        } else {
                            setQueryFrom(e.target.value);
                            debouncedFetchResultsFrom(value);
                            //console.log("Data");
                        }
                    }}
                    placeholder="From"
                />
                {resultsFrom.length > 0 &&
                <div className={`autosuggestion_from autosuggestion-react ${resultsFrom.length > 0 ? 'active' : ''}`}>
                    {loadingFrom && <ClipLoader css={override} size={20} aria-label="Loading Spinner" />}
                    <ul>
                        {resultsFrom.map((result) => (
                            <li key={result.air_id} onClick={() => handleSuggestionClickFrom(result)}>
                                <strong>{result.air_name}</strong> - {result.air_place} ({result.air_code})
                            </li>
                        ))}
                    </ul>
                </div>
                }
            </div>

            <div className="cust-form-group group-from-to group-to">
                <input
                    className="cust-form-control to-input"
                    type="text"
                    name="to"
                    value={queryTo}
                    onChange={(e) => {
                        //setToError('');
                        //setSelectedTo('');
                        const { value } = e.target;
                        //setQueryTo(value);
                        //debouncedFetchResultsTo(value);

                        if (value === '') { 
                            setQueryTo('');
                            debouncedFetchResultsTo('');
                            handleChange(index, 'to', '');
                        } else {
                            setQueryTo(e.target.value);
                            debouncedFetchResultsTo(value);
                        }

                    }}
                    placeholder="To"
                />                
                {resultsTo.length > 0 &&
                    <div className={`autosuggestion_to autosuggestion-react ${resultsTo.length > 0 ? 'active' : ''}`}>
                        {loadingTo && <ClipLoader css={override} size={20} aria-label="Loading Spinner" />}
                        <ul>
                            {resultsTo.map((result) => (
                                <li key={result.air_id} onClick={() => handleSuggestionClickTo(result)}>
                                    <strong>{result.air_name}</strong> - {result.air_place} ({result.air_code})
                                </li>
                            ))}
                        </ul>
                    </div>
                }
            </div>
            <div className="cust-form-group group-date from-date">
                <DatePicker
                    name="date"
                    placeholderText='Date'
                    className="cust-form-control date-input"
                    selected={row.date}
                    onChange={handleDateChange}
                    dateFormat="dd/MM/yyyy"
                    minDate={new Date()}
                />
            </div>
            <div className="cust-form-group group-time">
                <select className='cust-form-control time-input' name='time' value={row.time} onChange={handleInputChange}>
                    <option value="">Time</option>
                    {timeOptions.map((time, index) => (
                        <option key={index} value={time}>{time}</option>
                    ))}
                </select>
            </div>

            <div className="cust-form-group group-passenger">
                <select className="cust-form-control passenger-input" name='passenger' value={row.passenger} onChange={handleInputChange}>
                    {[...Array(19)].map((_, i) => (
                        <option key={i + 1} value={i + 1}>{i + 1}</option>
                    ))}
                </select>
            </div>                    
            <div className="cust-form-group group-luggage">
                <select className="cust-form-control luggage-input" name='bags' value={row.bags} onChange={handleInputChange}>
                    {[...Array(19)].map((_, i) => (
                        <option key={i + 1} value={i + 1}>{i + 1}</option>
                    ))}
                </select>
            </div>

            {showDeleteButton && (
                <div class="cust-form-group group-delete">
                    <a class="delete-btn" onClick={() => handleRemove(row.id)} href="javascript:void(0);" title="Delete">
                        <img src={airportappLocalizer.icon_delete} height="20" width="20" alt="Delete" />                        
                    </a>
                </div>
            )}
            
        </div>
    );
};

export default FormRow;
